import React, { useState } from 'react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Segment, Header, Container, Button } from 'semantic-ui-react';
import { searchContent } from '@plone/volto/actions';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';
import { isEmpty } from 'lodash';
import { Carousel } from '../';


const SLIDE_OPTIONS = {
	loop: false,
	autoplay: false,
	dots: false,
	buttons: true,
	customClass: 'announcements__slider',
	stopOnMouseEnter: true
}


const ItemView = props => {
	const { item } = props

	return (
		<>
			{item.getRemoteUrl ? (
				<UniversalLink href={item.remoteUrl} className=" announcementItem " key={item['@id']}>
					{item.title}
				</UniversalLink>
			) : (
				<UniversalLink href={flattenToAppURL(item['@id'])} className=" announcementItem " key={item['@id']}>
					{item.title}
				</UniversalLink>
			)}
		</>
	)

};


const Announcements = props => {
	const dispatch = useDispatch();
	const announcements = useSelector((state) => state.search.subrequests.announcements?.items);

	useEffect(() => {
		dispatch(
			searchContent(
				'/actualitat/avisos',
				{
					portal_type: ['Announcement'],
					sort_on: 'getObjPositionInParent',
					metadata_fields: ['getRemoteUrl', 'remoteUrl']
				},
				'announcements',
			),
		);
	}, [dispatch]);

	const [visible, setVisible] = useState(true);
	const toggleVisibility = () => {
		setVisible(!visible);
	};

	return (
		<>
			{(!isEmpty(announcements) && visible) ? (
				<Segment basic className='announcements px-0 d-print-none' as="section" aria-labelledby="announcements-title" >

					<Container className='position-relative'>

						<Header as="h2" className='announcements__title fs-5 d-flex flex-nowrap align-items-center' id="announcements-title">
							<FontAwesomeIcon icon={faTriangleExclamation} className='me-2' />
							<FormattedMessage id="Avisos" defaultMessage='Avisos' />
						</Header>

						<Carousel slides={announcements.slice(0, 8)} ItemView={ItemView} options={SLIDE_OPTIONS} />

						<Button className='announcements__close d-print-none' basic onClick={toggleVisibility}>
							<span className='visually-hidden'><FormattedMessage id="Tancar" defaultMessage='Tancar' /></span>
							<FontAwesomeIcon icon={faXmark} />
						</Button>

					</Container>

				</Segment>
			) : (
				<></>
			)}
		</>
	);
};

export default Announcements;